import { createRouter, createWebHistory } from 'vue-router'
import Perk from '../views/PerkNps.vue'
import UzbechkaSar from '../views/UzbechkaNps.vue'
import UzbechkaPen from '../views/UzbechkaPenzaNps.vue'
import Djos from '../views/DjosNps.vue'
import Hvanch from '../views/HvanchNps.vue'

const routes = [
  {
    path: '/',
    name: 'DJOS',
    component: Djos
  },
  {
    path: '/hvanch',
    name: 'HVANCH',
    component: Hvanch
  },
  {
    path: '/perk',
    name: 'PERK',
    component: Perk
  },
  {
    path: '/usbechka_sar',
    name: 'UZBECHKA_SAR',
    component: UzbechkaSar
  },
  {
    path: '/usbechka_pen',
    name: 'UZBECHKA_PENZA',
    component: UzbechkaPen
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router